export default __webpack_public_path__ + "static/media/drivability-checker-code-example.b9b41644.md";